import router from "@/routers/routerConfig";
import api from "@/stores/api";
import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: null,
    menu: [],
    isLoading: false,
    isValidated: false,
  }),
  getters: {
    isAuthenticated: (state) => state.isValidated && !!state.user,
    userName: (state) => state.user?.name || "",
  },
  actions: {
    async fetchUser() {
      try {
        this.isLoading = true;
        const response = await api().get("/auth/me");
        this.user = response.data;
        this.isValidated = true;
      } catch (error) {
        this.user = null;
        this.menu = [];
        this.isValidated = true;

        if (error.response) {
          console.warn("[Auth] Falha na validação de sessão:", {
            status: error.response.status,
            message: error.response.data?.detail || "Erro desconhecido",
          });
        } else if (error.request) {
          console.error("[Auth] Sem resposta do servidor:", error.message);
        } else {
          console.error("[Auth] Erro na configuração:", error.message);
        }

        throw error;
      } finally {
        this.isLoading = false;
      }
    },

    clearSession() {
      this.user = null;
      this.menu = [];
      this.isValidated = false;
      try {
        sessionStorage.clear();
      } catch {
        console.error("[AuthStore] Failed to clear session");
      }
    },

    async logout() {
      try {
        const response = await api().post("/auth/logout", null, {
          params: { skip_consent: true },
        });
        const logoutUrl = response.data.logout_url;

        this.clearSession();

        if (logoutUrl) {
          window.location.href = logoutUrl;
        } else {
          router.push({ name: "Login" });
        }
      } catch (error) {
        console.error("[Auth] Erro durante logout:", {
          message: error.message,
          status: error.response?.status,
        });

        this.clearSession();

        router.push({ name: "Login" });
      }
    },
  },
  persist: {
    storage: sessionStorage,
    paths: ["user"],
  },
});
